(() => {
  'use strict';
  const canonical = value => {
    const key = String(value || '').toLowerCase().replace(/^(resmed|philips(?: respironics)?)\s+/i, '').replace(/^dreamstation 1$/i, 'dreamstation').replace(/[^a-z0-9]/g, '');
    return ({lunag3auto: 'lunag3', transcendmicroautotravelcpap: 'transcendmicro'})[key] || key;
  };
  const initialize = () => document.querySelectorAll('[data-product-support]').forEach(root => {
    if (root.dataset.supportReady) { root.restoreVideoChoice?.(); return; }
    let videos, strings;
    try {
      videos = JSON.parse(root.querySelector('[data-product-support-videos]').textContent);
      strings = JSON.parse(root.querySelector('[data-product-support-strings]').textContent);
    } catch (_) { return; }
    videos = (Array.isArray(videos) ? videos : []).filter(item => item && typeof item.src === 'string' && item.src.startsWith('https://cdn.shopify.com/') && item.cpap && item.title);
    strings = strings && typeof strings === 'object' ? strings : {};
    const select = root.querySelector('[data-product-video-select]');
    const play = root.querySelector('[data-product-video-play]');
    const player = root.querySelector('[data-product-video-player]');
    const video = root.querySelector('[data-product-video]');
    const title = root.querySelector('[data-product-video-title]');
    const status = root.querySelector('[data-product-video-status]');
    const open = root.querySelector('[data-product-video-open]');
    let previousMachine, returnScroll = 0, playVersion = 0;
    const stop = () => {
      if (!video) return;
      playVersion += 1;
      video.pause(); video.removeAttribute('src'); video.removeAttribute('poster'); video.load();
      player.hidden = true; status.textContent = '';
    };
    const tablist = root.querySelector('[data-support-tabs]');
    const tabs = [...root.querySelectorAll('[data-support-tab]')];
    const panels = [...root.querySelectorAll('[data-support-panel]')];
    const mobile = window.matchMedia('(max-width: 700px)');
    const orientation = () => tablist.setAttribute('aria-orientation', mobile.matches ? 'horizontal' : 'vertical');
    const showTab = (key, {focus = false, updateURL = false} = {}) => {
      const active = tabs.find(tab => tab.dataset.supportTab === key) || tabs[0];
      if (!active) return;
      if (active.dataset.supportTab !== 'video') stop();
      tabs.forEach(tab => {
        const selected = tab === active;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.supportPanel !== active.dataset.supportTab; });
      root.dataset.activeSupportTab = active.dataset.supportTab;
      if (focus) active.focus({preventScroll: true});
      if (updateURL) history.replaceState(history.state, '', '#' + active.getAttribute('aria-controls'));
    };
    const restoreTabFromHash = () => {
      const target = panels.find(panel => '#' + panel.id === window.location.hash);
      if (target) showTab(target.dataset.supportPanel);
      else if (window.location.hash === '#' + root.id) showTab('faq');
    };
    tablist.setAttribute('role', 'tablist');
    orientation(); mobile.addEventListener('change', orientation);
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.addEventListener('click', () => showTab(tab.dataset.supportTab, {updateURL: true}));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === (mobile.matches ? 'ArrowRight' : 'ArrowDown')) next = (index + 1) % tabs.length;
        else if (event.key === (mobile.matches ? 'ArrowLeft' : 'ArrowUp')) next = (index - 1 + tabs.length) % tabs.length;
        if (next !== undefined) {
          event.preventDefault();
          showTab(tabs[next].dataset.supportTab, {focus: true, updateURL: true});
        }
      });
    });
    panels.forEach(panel => { panel.setAttribute('role', 'tabpanel'); panel.tabIndex = 0; });
    tablist.hidden = false;
    showTab('faq'); restoreTabFromHash();
    window.addEventListener('hashchange', restoreTabFromHash);

    if (select && video) {
      const chosen = () => select.value === '' ? null : videos[Number(select.value)];
      const update = () => { stop(); play.disabled = !chosen(); };
      videos.forEach((item, index) => select.add(new Option(item.cpap, String(index))));
      select.disabled = videos.length === 0;
      select.addEventListener('change', update);
      root.restoreVideoChoice = () => {
        const plan = window.ELPowerPlan?.read() || {};
        const machine = plan.machine || '';
        const identity = (plan.brand || '') + ':' + machine;
        if (identity === previousMachine) return;
        previousMachine = identity;
        const match = videos.findIndex(item => {
          const brand = /^resmed/i.test(item.cpap) ? 'ResMed' : /^philips/i.test(item.cpap) ? 'Philips Respironics' : /^(luna|bmc)/i.test(item.cpap) ? 'Luna / React Health' : 'Other supported families';
          return (!plan.brand || plan.brand === brand) && canonical(item.cpap) === canonical(machine);
        });
        select.value = match >= 0 ? String(match) : '';
        update();
      };
      play.addEventListener('click', () => {
        const item = chosen(); if (!item) return;
        const version = ++playVersion;
        returnScroll = window.scrollY;
        title.textContent = item.title; open.href = item.src;
        video.setAttribute('aria-label', item.title);
        if (item.poster) video.poster = item.poster;
        video.src = item.src; player.hidden = false; status.textContent = '';
        video.focus();
        video.play().catch(() => { if (version === playVersion && !player.hidden && !video.error) status.textContent = strings.playPrompt; });
      });
      video.addEventListener('error', () => { if (!player.hidden) status.textContent = strings.error; });
      root.querySelector('[data-product-video-close]').addEventListener('click', () => {
        stop(); play.focus({preventScroll: true}); window.scrollTo({top: returnScroll, behavior: 'instant'});
      });
      window.addEventListener('el:power-plan:change', root.restoreVideoChoice);
      root.restoreVideoChoice();
    }
    root.dataset.supportReady = 'true';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true}); else initialize();
  window.addEventListener('pageshow', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
